/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import XDownloader from './Classes/XDownloader';
import ResponsiveTable from './Classes/ResponsiveTable';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var downloaderInstance = null;
var responsiveTableInstance = null;

import xdownloaderConfig from './xdownloader-config';

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 2,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  downloaderInstance = new XDownloader(xdownloaderConfig);

  // downloaderInstance = new XDownloader({
  //   downloadText: "Download xslx", //Can be empty if you want to use an icon instead
  //   backgroundColor: "6ab04c", //Colored Cells Background
  //   backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
  //   borderColor: '608c3e', //Color of border
  //   borderColor2: 'B3AEA6', //Color of border
  //   borderStyle: 'thick', // thin/dotted/medium/double/thick
  //   borderStyle2: 'thin', // thin/dotted/medium/double/thick
  //   headClass: 'head', //Class you want your columns based on. Will be bold in Excel
  //   boldClass: 'gline_bold', //Class for Bold text in Excel
  //   boldClass2: 'line_bold', //Class for Bold text in Excel
  //   borderClass: 'head',
  //   borderClass2: 'noline',
  //   fontColorHighlight: '608c3e', //Color of highlight-text in spans,
  //   spanClassHighlight: 'green' //Class of highlight-text in spans - characterstyle in excel
  // });

});
